import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Check, X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './components/ui/dialog';
import { Button } from './components/ui/button';

interface ScheduleConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedDate: Date | undefined;
  selectedTime: string | null;
  onConfirm: () => void;
}

const ScheduleConfirmationDialog: React.FC<ScheduleConfirmationDialogProps> = ({
  open,
  onOpenChange,
  selectedDate,
  selectedTime,
  onConfirm
}) => {
  if (!selectedDate || !selectedTime) return null;

  const formattedDate = format(selectedDate, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] max-w-[425px] p-4 sm:p-6 bg-white/10 backdrop-blur-sm border border-white/10 mx-4">
        <DialogHeader className="flex flex-col items-center text-center pb-3 sm:pb-4 md:pb-[16px]">
          <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-[64px] md:h-[64px] rounded-full bg-[#1777CF]/80 flex items-center justify-center mb-3 sm:mb-4 md:mb-[16px]">
            <Check className="w-6 h-6 sm:w-7 sm:h-7 md:w-[32px] md:h-[32px] text-white" />
          </div>
          <DialogTitle className="text-base sm:text-lg md:text-[20px] font-semibold text-white">
            Confirmar agendamento
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3 sm:gap-4 md:gap-[16px] text-sm sm:text-base md:text-[16px] text-white/80">
          <p className="text-center">
            Você está confirmando o agendamento para:
          </p>
          <div className="bg-white/5 border border-white/10 p-3 sm:p-4 md:p-[16px] rounded-[8px]">
            <p className="font-medium text-white">Data: <span className="font-normal text-white/80">{formattedDate}</span></p>
            <p className="font-medium text-white">Horário: <span className="font-normal text-white/80">{selectedTime}</span></p>
          </div>
          <p className="text-center">
            Após a confirmação, entraremos em contato para combinar os detalhes do agendamento.
          </p>
        </div>
        <div className="flex justify-end gap-2 sm:gap-3 md:gap-4 mt-4">
          <Button 
            variant="ghost" 
            onClick={() => onOpenChange(false)}
            className="text-white"
          >
            Cancelar
          </Button>
          <Button 
            onClick={onConfirm}
          >
            Confirmar
          </Button>
        </div>
        <button
          onClick={() => onOpenChange(false)}
          className="absolute right-3 sm:right-4 top-3 sm:top-4 rounded-full p-1 sm:p-[4px] text-white/70 hover:text-white transition-colors focus:outline-none"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Fechar</span>
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleConfirmationDialog; 